<bci-wk-modal class="modal">
  <div class="container-modal">
    <img
      class="war"
      src="./assets/images/warning-sucursal.png"
      alt="waricon"
    />
    <div class="title wk-padding-top-24">
      <bci-wk-modal-title bciWkTypeH600
        >Selecciona otra región, comuna o sucursal</bci-wk-modal-title
      >
    </div>
    <div class="subtitle">
      <p>
        La sucursal que seleccionaste no tiene horario de agendamiento para el
        motivo de tu visita. Puedes seleccionar otra o asistir a la sucursal de
        tu preferencia sin agendamiento.
      </p>
    </div>
    <bci-wk-modal-actions>
      <button bciWkButtonPrimary (click)="close()">Entendido</button>
    </bci-wk-modal-actions>
  </div>
</bci-wk-modal>
